import { render, staticRenderFns } from "./ManuscriptTable.vue?vue&type=template&id=0c29ba51&scoped=true&"
import script from "./ManuscriptTable.vue?vue&type=script&lang=js&"
export * from "./ManuscriptTable.vue?vue&type=script&lang=js&"
import style0 from "./ManuscriptTable.vue?vue&type=style&index=0&id=0c29ba51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c29ba51",
  null
  
)

export default component.exports